import {Component, Input, OnInit} from '@angular/core';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {Router} from '@angular/router';
import Swal, {default as swal} from 'sweetalert2';
import {FormControl, FormGroup} from '@angular/forms';
import {ReversedBlacklistService} from '../../../shared/service/reversed-blacklist.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ReversedSuspendService} from '../../../shared/service/reversed-suspend.service';
import {Status} from '../../../shared/enums/status.enum';
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {ReversedSuspendBlacklistService} from '../../../shared/service/reversed-suspend-blacklist.service';
import {ApplicantRequestService} from '../../../service/applicant-request.service';

@Component({
  selector: 'app-reversed-return-request-details',
  templateUrl: './reversed-return-request-details.component.html',
  styleUrls: ['./reversed-return-request-details.component.scss']
})
export class ReversedReturnRequestDetailsComponent implements OnInit {

  remarkForm: FormGroup;
  @Input() fromParent;
  approvalModel: ApprovalModel = new ApprovalModel();
  isError: boolean = false;
  isSucess: boolean = false;

  constructor(private blacklistService: ReversedBlacklistService,
              private router: Router, private activeModal: NgbActiveModal,
              private susupendService: ReversedSuspendService,
              private reversedSuspendBlacklistService: ReversedSuspendBlacklistService,
              public applicantRequestService: ApplicantRequestService) { }

  ngOnInit() {
    this.approvalModel = this.fromParent.model;
    this.remarkForm = new FormGroup({
      remark: new FormControl(null),
    });
  }

  submitRequest() {
    this.approvalModel.remark = this.remarkForm.value.remark;
    if (this.approvalModel.process === ActionMode.REJECT) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.blacklistService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
              this.activeModal.close({ status: 'Saved', data: "" });

              this.router.navigate(['/dashboard/dashHome'] );
              this.blacklistService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }

    if(this.approvalModel.process === ActionMode.BLACKLIST) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.blacklistService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
              this.activeModal.close({ status: 'Saved', data: "" });
              console.log(this.approvalModel.type);
              this.router.navigate(['/dashboard/reversed-blacklist-verification',this.approvalModel.type] );
              this.blacklistService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.SUSPEND){
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.susupendService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              swal.fire("Success", "Details submitted successfully", "success");
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/reversed-suspend-verification/')) {
                this.router.navigate(['/dashboard/reversed-suspend-verifications',this.approvalModel.type]);
              }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }else if(this.approvalModel.process === ActionMode.REVERSE_SUSPEND_BLACKLIST) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to return the request?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes!',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.reversedSuspendBlacklistService.returnRequest(this.approvalModel).subscribe(
            (success: string) => {
              console.log('111');
              swal.fire("Success", "Details submitted successfully", "success");
              this.activeModal.close({ status: 'Saved', data: "" });

              if(this.router.url.includes('/dashboard/reversed-suspend-verification/')) {
                this.router.navigate(['/dashboard/reversed-suspend-verification',this.approvalModel.type]);
              }
              if(this.router.url.includes('/dashboard/reversed-suspend-blacklist-verification/')){
                console.log(this.router.url);
                this.router.navigate(['/dashboard/reversed-suspend-blacklist-verification',this.approvalModel.type]);
              }
              this.blacklistService.close();
            },
            (error) => {
              swal.fire("Sorry!", "Error When Updating the Request...!", "error");
            },
          );
        } else {
        }
      });
    }
  }

}
